module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_trade_in_360__;